module.exports = __webpack_public_path__ + "assets/img/18_1803.696dd9bc.jpg";